<template>
  <div>
    <vggrid :list="list" tableheight="400" flexname="" :cols="pexCols"
            :showfooter="false" :showPage="false" :resizable="true">
    </vggrid>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'

  export default {
    name: 'projectScoringSumIndex',
    components: {vggrid},
    props: {
      projectid: Number,
      activeName: {},
    },
    data () {
      return {
        project:{},
        list:[],
        pexCols:[
          {field: 'pexpertname', fieldtype: 'C', title: '申请人', calculExpr: '', addNewRowFlg: false},
          {field: 'pexchangetypename', fieldtype: 'C', title: '修改类型', calculExpr: '', addNewRowFlg: false},
          {field: 'pexchangetime', fieldtype: 'T', title: '申请时间', calculExpr: '',formatter: ['toDateString', ''], addNewRowFlg: false},
          {field: 'pexchangestatusname', fieldtype: 'C', title: '审核状态', calculExpr: '', addNewRowFlg: false},
          {field: 'username', fieldtype: 'C', title: '审核人', calculExpr: '', addNewRowFlg: false},
          {field: 'pexchangeretime', fieldtype: 'T', title: '审核时间', calculExpr: '',formatter: ['toDateString', ''], addNewRowFlg: false},
          { title: '操作 ', width: 160, showOverflow: true,
            slots: {
              default: ({row}) => {
                    if(+row.pexchangestatus === 1){
                      return [<vxe-button onClick={this.toGoReview.bind(this, row)}>审核</vxe-button>]
                    }
                    else{
                      return [<vxe-button onClick={this.viewReview.bind(this, row)}>查看</vxe-button>]
                    }
              }}
          }
        ],
      }
    },
    created () {
      this.getModel()
      this.getReviewList()
    },
    activated () {
    },
    mounted () {
    },
    watch: {
      activeName () {
        if(this.activeName === 'shxg') {
            this.getModel()
            this.getReviewList()
        }
      }
    },
    methods: {
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.projectid}
        })
        this.project = res
      },
      async getReviewList(){
        let res = await request({
          method: 'get',
          url: 'xmgl/project/getReviewList',
          params: {projectid: this.projectid}
        })
        this.list = res
      },
      async toGoReview(row){
          this.$router.push({name: 'projectReviewScore',params: {pexchangeid:row.pexchangeid,type:1}})
      },
      async viewReview(row){
          this.$router.push({name: 'projectReviewScore',params: {pexchangeid:row.pexchangeid,type:2}})
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>